module.exports = __webpack_public_path__ + "media/images/socials/twitter-2adda41b8dafa2e93fcade50d46d6835.png";